<template>
  <div class="slider-magazine pb-6 md:pb-8 border-b w-full relative overflow-hidden">
    <h3 class="text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack tracking-wider">當月雜誌</h3>
    <swiper :options="magazineOption" class="swiper">
      <swiper-slide v-for="item in magazineData" :key="item.cover" class="slider-magazine-item cursor-pointer flex flex-col">
        <router-link :to="{ name: 'productsList', params: { category: 'magazine' }, query: { type: 'MAGAZINE', category: item.category_id }}" class="block w-full" :alt="item.category_name" :aria-label="item.category_name">
          <div class="magazine-inner bg-white w-full">
            <div class="square-img" v-lazy:background-image="{ src: item.cover }"></div>
          </div>
        </router-link>
        <p class="text-center mt-3 md:mt-4 text-sm md:text-base textColorDarkBlack">{{ item.introduction }}</p>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  props: {
    magazineData: {
      type: Array
    }
  },
  data () {
    return {
      magazineOption: {
        preloadImages: true,
        updateOnImagesReady: true,
        slidesPerView: 6,
        watchOverflow: true,
        loop: true,
        effect: 'slide',
        breakpoints: {
          576: {
            slidesPerView: 3
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    transition: .3s;
  }
  .swiper-container {
    overflow: visible !important;
    min-height: 10vh;
    @media (min-width: 768px) {
      min-height: 20vh;
    }
  }
  .slider-magazine-item {
    .magazine-inner {
      position: relative;
      width: 100%;
      padding-bottom : 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: white;
      .square-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding-bottom : 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        transition: .3s;
      }
    }
  }
</style>
